import utils from '../utils.js';

function isAxiosError(payload){return utils.isObject(payload)&&payload.isAxiosError===true}

export { isAxiosError as default };
//# sourceMappingURL=isAxiosError.js.map
